import { filter } from 'rxjs/operators';
import { AsistentesPopupComponent } from './../asistentes-popup/asistentes-popup.component';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DropDownModel } from 'app/modules/common/entities/DropDownModel';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';
import { VisitaEmpresaSaveModel } from 'app/modules/coordinator/entities/visita-empresa';
import { CoordinatorCompanyService } from 'app/modules/coordinator/services/coordinator-company.service';
import { Moment } from 'moment';

@Component({
    selector: 'app-add-edit-visita-empresa',
    templateUrl: './add-edit-visita-empresa.component.html',
    styleUrls: ['./add-edit-visita-empresa.component.scss'],
    standalone: false
})
export class AddEditVisitaEmpresaComponent implements OnInit {

  public isEdit = false;
  public title = '';
  public visitaEmpresaForm: UntypedFormGroup;
  public saveModel: VisitaEmpresaSaveModel = new VisitaEmpresaSaveModel();
  public typeList$: Array<DropDownModel>;
  public contactList:any;
  conactText:string="";

  public minDate = null;
  public maxDate = null;

  public selectedContact:any [];

  constructor(
    private dialogRef: MatDialogRef<AddEditVisitaEmpresaComponent>,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private coordinatorCompanyService: CoordinatorCompanyService) { }

  ngOnInit(): void {
    this.title = this.isEdit ? 'Editar visita a la empresa' : 'Agregar visita a la empresa';
    this.initForm();
    this.initTypeDropdown();
    this.getPersonalContacto()

  }

  private initForm(): void {
    this.visitaEmpresaForm = this.formBuilder.group({
      Id: [this.saveModel.Id],
      PlannedDate: [this.saveModel.PlannedDate, Validators.required],
      DoneDate: [this.saveModel.DoneDate],
      Type: [this.saveModel.Type, Validators.required],
      Assistant: [this.saveModel.Assistant],
      Concept: [this.saveModel.Concept],
      Description: [this.saveModel.Description, Validators.maxLength(500)],
      CompanyId: [this.saveModel.CompanyId, Validators.required],
      AsistentesEmpresa: [this.saveModel.AsistentesEmpresa],
      AsistentesMutua: [this.saveModel.AsistentesMutua],
      Comentarios: [this.saveModel.Comentarios],
    });
    this.setMinMaxDates('T');
  }

  private getPersonalContacto()
  {
    this.contactList=[]
    this.selectedContact=[];
    this.coordinatorCompanyService.GetPersonalContacto(this.saveModel.CompanyId.toString()).subscribe(res=>{
      if(res.result.length>0)
      {
        res.result.forEach(element => {
          let object =element;
          this.contactList.push(object)
        });

        if(this.saveModel.AsistentesEmpresa=== undefined)
        {
        }else{
         
          const arr = this.visitaEmpresaForm.get('AsistentesEmpresa')?.value.split(';');
          if(arr.length>0)
          {
            arr.forEach(element => {
              var nameArr = element.split('(');
              const result = this.contactList.filter((obj) => {
                return obj.nombre === nameArr[0].trim();
              });
              if(result.length > 0)
              {
                result.forEach(contact => {
                  this.selectedContact.push(contact.id)
                });
              }
            });
          }
        }
      }
    })
  }

  private initTypeDropdown(): void {
    this.typeList$ = new Array<DropDownModel>();
    this.typeList$.push({value: 'Contacto Telefónico', viewValue: 'Contacto Telefónico'});
    this.typeList$.push({value: 'Visita Coordinador', viewValue: 'Visita Coordinador'});
  }

  public cancel(isSaved = false): void {
    this.dialogRef.close(isSaved);
  }

  public openAddEditPopup(): void {
    const modalRef = this.dialog.open(AsistentesPopupComponent, {
    
    });
    modalRef.componentInstance.empresaId = this.saveModel.CompanyId;
    modalRef.componentInstance.contactList = this.contactList;
    modalRef.componentInstance.selectedContact = this.selectedContact;

    modalRef.afterClosed().subscribe(contactString => {

      this.conactText=contactString;
      if(contactString!=undefined)
      {
        this.visitaEmpresaForm.patchValue({
          AsistentesEmpresa:contactString
        })
      }
    });
  }

  public saveVisitaEmpresa(): void {
    this.visitaEmpresaForm.markAllAsTouched();
    if (this.visitaEmpresaForm.valid) {
      this.mapFormtoSaveModel();
      this.coordinatorCompanyService.AddEditVisitaEmpresa(this.saveModel).subscribe(res => {
        if(res.code === 0 && res.result) {
          this.sharedService.ShowSnackBar('Guardó los datos de la visita con éxito.');
          this.cancel(true);
        } else {
          this.sharedService.ShowSnackBar('No se pudieron guardar los datos de la visita.');
        }
      }, error => {
        console.error(error);
        this.sharedService.ShowSnackBar('Ha ocurrido un error. Por favor intente de nuevo.');
      });
    } else {
      this.sharedService.ShowSnackBar('Ingrese datos válidos para continuar.');
    }
  }

  private mapFormtoSaveModel(): void {
    this.saveModel = this.visitaEmpresaForm.value;
    let date: Moment = this.visitaEmpresaForm.get('PlannedDate').value;
    this.saveModel.PlannedDate = typeof date === 'string' ? date : DateHelper.getUTCDateString(DateHelper.getNativeDate(date));
    date = this.visitaEmpresaForm.get('DoneDate').value;
    this.saveModel.DoneDate = typeof date === 'string' ? date : DateHelper.getUTCDateString(DateHelper.getNativeDate(date));
  }

  public setMinMaxDates(type: string): void {
    if(type === 'F') {
      this.minDate = this.visitaEmpresaForm.get('PlannedDate').value;
    } else {
      this.maxDate = this.visitaEmpresaForm.get('DoneDate').value;
    }
    
  }

}
